/**
 * Get user initials from first and last name
 * @param firstName - The person's first name
 * @param lastName - The person's last name
 * @param fallback - Value to display if no initials available (defaults to em dash)
 * @returns User initials in uppercase or fallback value
 */
export const getUserInitials = (firstName: Maybe<string>, lastName: Maybe<string>, fallback = "\u2014"): string => {
  const initials = `${firstName?.[0] || ""}${lastName?.[0] || ""}`;
  return initials ? initials.toUpperCase() : fallback;
};

/**
 * Format user count display text
 * @param filteredCount - Number of users after filtering
 * @param userCount - Total number of users
 * @returns Formatted display text (e.g., "10 users" or "5 of 10 users")
 */
export const formatUserCount = (filteredCount: number, userCount: number): string => {
  if (filteredCount === userCount) {
    return `${userCount} user${userCount === 1 ? "" : "s"}`;
  }
  return `${filteredCount} of ${userCount} user${userCount === 1 ? "" : "s"}`;
};
